export function AppLoadingScreen() {
	return (
		<div 
			className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
			style={{
				background: "linear-gradient(180deg, #F8F4C5 0%, #E4C5FF 49.52%, #F8F4C5 100%)",
			}}
		>
			<div className="flex items-center justify-center gap-3">
				<svg
					className="animate-spin w-8 h-8 sm:w-10 sm:h-10"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
				>
					<circle
						className="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="currentColor"
						strokeWidth="4"
						style={{ color: "#10333B" }}
					></circle>
					<path
						className="opacity-75"
						fill="currentColor"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
						style={{ color: "#10333B" }}
					></path>
				</svg>
				<span 
					className="text-xl sm:text-2xl"
					style={{ 
						color: "#10333B",
						fontFamily: "var(--font-inter), Inter, sans-serif",
					}}
				>
					Loading...
				</span>
			</div>
		</div>
	);
}

